module.exports = __webpack_public_path__ + "static/Christian-Wenz-2020.deaaf00f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Christian-Wenz-2020.jpg
// module id = 50
// module chunks = 168707334958949